import { graphql } from '@/gql';
import type { HomeServiceOrderProviderPaymentInputType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderProviderPayment } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderProviderPaymentFragment';

export const updateHomeServiceOrderProviderPayment = async (id: number, data: HomeServiceOrderProviderPaymentInputType) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
    },
    mutation: graphql(`
      mutation UpdateHomeServiceOrderProviderPayment($id: Float!, $data: HomeServiceOrderProviderPaymentInputType!) {
        updateHomeServiceOrderProviderPayment(id: $id, data: $data) {
          ...HomeServiceOrderProviderPaymentFragment
        }
      }
    `),
  });

  return response.data?.updateHomeServiceOrderProviderPayment as HomeServiceOrderProviderPayment;
};
